import * as React from "react"
import { cn } from "@utils/utils"
import { Spinner } from "@ui/Spinner"

export interface LoadingOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  isLoading?: boolean
  text?: string
  spinnerSize?: "sm" | "default" | "lg" | "xl" | "2xl" | "3xl"
  spinnerVariant?: "default" | "secondary" | "destructive" | "muted"
}

const LoadingOverlay = React.forwardRef<HTMLDivElement, LoadingOverlayProps>(
  ({ 
    className, 
    isLoading = false, 
    text = "Procesando...", 
    spinnerSize = "lg",
    spinnerVariant = "default",
    ...props 
  }, ref) => {
    if (!isLoading) return null;

    return (
      <div
        ref={ref}
        className={cn(
          "fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 backdrop-blur-sm",
          className
        )}
        {...props}
      >
        <div className="flex flex-col items-center gap-4 rounded-lg bg-white/90 p-6 shadow-lg backdrop-blur-sm">
          <Spinner size={spinnerSize} variant={spinnerVariant} />
          {text && (
            <p className="text-sm font-medium text-gray-700">{text}</p>
          )}
        </div>
      </div>
    )
  }
)
LoadingOverlay.displayName = "LoadingOverlay"

export { LoadingOverlay } 